import { localization } from '@ocean/configs'

const { i18n } = localization

class LocalizationUtils {
  private defaultErrorKey = 'commonDefaultError'
  private defaultErrorsNamespace = 'errors'

  localizeError(errorCode?: string, details?: any): string {
    const errorKey = `${this.defaultErrorsNamespace}.${errorCode}`
    if (i18n.exists(errorKey)) {
      return i18n.t(errorKey, details)
    }
    return i18n.t(`${this.defaultErrorsNamespace}.${this.defaultErrorKey}`)
  }
}

export default new LocalizationUtils()
